import { z } from "zod";
import { catalogueLocale } from "../catalog/vocabulary";
/**
 * `GET /me/recovery?locale=pt` — muscle readiness (`D203`).
 *
 * ── A MODEL OF THE LOGGED SETS, AND NOTHING ELSE ────────────────────────────
 * Per training muscle (the catalogue's twelve), the fatigue the last seven
 * days of sets left, decayed by time, as a readiness from 0 (just trained
 * hard) to 1 (recovered). A sore check-in caps the muscles it names at 0.5.
 * Sleep, stress, nutrition and age are NOT in it, and the screen says so: a
 * number that looks physiological and is not would be the thing `D104`
 * forbids — a claim about the person the data cannot back.
 *
 * The arithmetic is `packages/modules/training/src/core/model/recovery.ts`.
 *
 * ── ONLY THE MUSCLES THE WINDOW TOUCHED ─────────────────────────────────────
 * A muscle with no set in the window and no sore report is fully recovered
 * and is ABSENT, not listed at 1: the twelve names would cost a catalogue
 * read for muscles there is nothing to say about. The client draws an absent
 * muscle as recovered.
 */
export const recoveryQuery = z.object({
    /** The locale muscle names are in. English when absent. */
    locale: catalogueLocale.optional(),
});
export const recoveryMuscle = z.object({
    muscleId: z.int().positive(),
    /** In the request's locale. */
    name: z.string().min(1),
    /** 0 (just trained hard) … 1 (recovered). */
    readiness: z.number().min(0).max(1),
    /** The newest set in the window that worked it, as target or synergist;
     *  `null` for a muscle listed only because a check-in named it. */
    lastTrainedAt: z.iso.datetime().nullable(),
    /** A check-in in the last three days said it was sore — readiness is then
     *  at most 0.5 whatever the sets say. */
    sore: z.boolean(),
});
export const recoveryOutput = z.object({
    /** The instant the decay was computed at. */
    asOf: z.iso.datetime(),
    /** Least recovered first, ties by `muscleId`. */
    muscles: z.array(recoveryMuscle),
});
//# sourceMappingURL=recovery.js.map